import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { t } from '../../i18n';

/** <cadence-loading> — centered spinner used while data/auth state resolves. */
@customElement('cadence-loading')
export class CadenceLoading extends LitElement {
  @property() label = '';

  static styles = css`
    :host { display: grid; place-items: center; padding: var(--space-6); min-height: 160px; }
    .wrap { display: flex; flex-direction: column; align-items: center; gap: 12px; color: var(--color-text-secondary); }
    .spinner {
      width: 28px; height: 28px; border-radius: 50%;
      border: 3px solid var(--color-border); border-top-color: var(--color-primary);
      animation: spin 0.7s linear infinite;
    }
    @keyframes spin { to { transform: rotate(360deg); } }
  `;

  render() {
    return html`
      <div class="wrap" role="status" aria-live="polite">
        <span class="spinner" aria-hidden="true"></span>
        <span>${this.label || t('common.states.loading')}</span>
      </div>
    `;
  }
}
